$ = require 'jquery'
Auth = require 'db/auth'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
Confirm = require 'views/lib/confirm'
SharePopoverView = require 'views/board/share-popover-view'
EditEmailSettingsView = require 'views/board-menu/edit-email-settings-view'
CopyBoardView = require 'views/board/copy-board-view'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
boardMenuMore = require 'views/templates/board_menu_more'
ClientConfig = require 'debug/client-config'
ModelLoader = require 'db/model-loader'
BoardAddToTeam = require 'views/board-menu/board-add-to-team-view'
getExperiment = require 'lib/experiments/simple-test'

module.exports = class BoardMenuMoreView extends View
  viewTitleKey: 'more'
  isTopLevelTab: true

  initialize: ({ @sidebarView }) ->
    @listenTo @model,
      'change:subscribed': @renderSubscribeState
    @listenTo @model, 'cancel-add-to-team', =>
      @addToTeam = false
      @render()
    @listenTo @model, 'add-to-team', =>
      if !@model.owned()
        # We aren't an admin on this board so redirect to business-class page
        window.location = '/business-class'
      else
        @addToTeam = true
        @render()

  className: 'board-menu-content-frame'

  events:
    'click .js-open-collections': 'openCollections'
    'click .js-open-settings': 'openSettings'
    'click .js-open-stickers': 'openStickers'
    'click .js-open-labels': 'openLabels'
    'click .js-open-archive': 'openArchivedItems'
    'click .js-share': 'shareBoard'
    'click .js-email': 'openEmailSettings'
    'click .js-board-subscribe': 'toggleSubscribe'
    'click .js-copy-board': 'copyBoard'
    'click .js-close-board': 'closeConfirm'
    'click .js-leave-board': 'leaveConfirm'
    'click .js-short-url': 'selectUrl'
    'submit form': 'cancel'

  render: (e) ->
    # clears sidebar menu
    @$el.empty()

    me = Auth.me()

    data = @model.toJSON()
    data.canJoin = @model.canJoin()
    data.canInviteMembers = @model.canInviteMembers()
    data.confirmed = me.get('confirmed')
    data.isLoggedIn = me.isLoggedIn()

    org = @model.getOrganization()

    data.canCloseBoard = @model.owned() || (org?.isFeatureEnabled('superAdmins') && org?.owned())

    data.editableByMember = @model.editableByMember(me)
    data.canLeaveBoard = (@model.isMemberObserver(me) || @model.editableByMember(me)) && me.getMembershipData(@model).canRemove
    data.canCloseOrLeave = data.canLeaveBoard || data.canCloseBoard

    data.pLevelClass = BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)
    data.pLevelAltText = BoardDisplayHelpers.getPermLevelAltTextForBoard(@model)
    data.helperText = l(['board perms', @model.getPermLevel(), 'short summary'])

    collectionsEnabled = org?.isFeatureEnabled('tags')
    data.showCollections = collectionsEnabled || !ClientConfig.get('dontUpsell')

    if @addToTeam
      @renderAddToTeam()
    else
      @$el.html(boardMenuMore(data))
      @renderSubscribeState()

    @

  renderAddToTeam: ->
    ModelLoader.loadMyOrganizations()

    @appendSubview @subview(BoardAddToTeam, @model, {
      menuType: "More"
    })

  renderSubscribeState: ->
    data = @model.toJSON()

    # EXPERIMENT: subscribeToWatchOrFollow
    subscribeToWatchOrFollow = getExperiment 'subscribeToWatchOrFollow'
    subscribeString = 'subscribe'

    if subscribeToWatchOrFollow?.inExperiment and subscribeToWatchOrFollow.get('variation') != 'control'
      subscribeString = subscribeToWatchOrFollow.get('variation')

    @$('.js-subscribed-state').html(
      templates.fill(
        'board_menu_subscribed_state',
        _.extend(data, { 'subscribeString': subscribeString })
      )
    )

    return

  openCollections: (e) ->
    Util.stop(e)

    @sidebarView.pushView 'collections'
    track("Board Menu", "Open Board Collections", "Via Sidebar Menu")
    return

  openSettings: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'settings'
    track("Board Menu", "Open Settings")
    return

  openLabels: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'labels'
    track("Board Menu", "Open Labels")
    return

  openStickers: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'stickers'
    track("Board Menu", "Open Stickers", "Via More Menu")
    return

  openArchivedItems: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'archive'
    track("Board Menu", "Open Archived Items")
    return

  shareBoard: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$(e.target).closest('.js-share')
      view: new SharePopoverView({ @model, @modelCache })

    track("Board Menu", "Open Share, Print, and Export Menu")

    return

  openEmailSettings: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$(e.target).closest('.js-email')
      view: new EditEmailSettingsView({ @model, @modelCache })

    track('Board Menu', 'Open Email Settings - Menu')

    return

  copyBoard: (e) ->
    Util.stop(e)

    if !$(e.target).hasClass('disabled')
      track("Board Menu", "Open Copy Board")

      PopOver.toggle
        elem: @$(e.target).closest('.js-copy-board')
        view: new CopyBoardView({ @model, @modelCache })

    return

  toggleSubscribe: (e) ->
    Util.preventDefault(e)

    if !$(e.target).hasClass('disabled')
      @model.subscribe !@model.get('subscribed')
      track("Board Menu", "Subscribe/Unsubscribe")

    return

  closeConfirm: (e) ->
    Util.stop(e)
    track("Board Menu", "Open Close Menu")

    Confirm.toggle 'close board',
      elem: $(e.target).closest('a')
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.close()
        track("Board", "Close Board")

    return

  leaveConfirm: (e) ->
    Util.stop(e)
    track("Board Menu", "Open Leave Menu")

    me = Auth.me()
    key = me.removeMembershipConfirmationKey(@model)

    Confirm.toggle key,
      elem: $(e.target).closest('a')
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.removeMember(me)
        track("Board", "Leave Board")

    return

  selectUrl: (e) ->
    @$('.js-short-url').focus().select()

  cancel: (e) ->
    Util.stop(e)
    false



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-menu-more-view.coffee